import { BaseComponentService } from 'src/app/services/_app/base-component.service';
import { LicenseAssignment } from 'src/app/models/license/license-assignment';
import { ApiPagination } from 'src/app/models/api/api-pagination.model';
import { LicenseService } from 'src/app/services/license.service';
import { License } from 'src/app/models/license/license.model';
import { ApiError } from 'src/app/models/api/api-error.model';
import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-license-details',
  templateUrl: './license-details.component.html',
  styleUrl: './license-details.component.scss',
})
export class LicenseDetailsComponent implements OnInit {
  private _licenseService: LicenseService = inject(LicenseService);
  private _baseComponentService = inject(BaseComponentService);
  private _route: ActivatedRoute = inject(ActivatedRoute);
  public error?: ApiError = undefined;
  public loading: boolean = true;

  public listingError?: ApiError = undefined;
  public listingLoading: boolean = true;
  public pagination?: ApiPagination;

  private _licenseId?: string;
  public license?: License;
  public licenseAssignmentsListing: LicenseAssignment[] = [];

  ngOnInit(): void {
    this._route.params.subscribe((params) => {
      if (params['id']) this._licenseId = params['id'];
      this.getLicenseData();
    });
  }

  public onPage(event: number): void {
    if (this.pagination) {
      this.pagination.page = event;
      this.getLicenseAssignmentsListing();
    }
  }

  async getLicenseData() {
    this.loading = true;
    this.error = undefined;
    this.license = undefined;
    this._licenseService
      .getLicenseDetails(this._licenseId)
      .subscribe({
        next: (response: any) => {
          this.license = new License(response.data);
          setTimeout(() => this.getLicenseAssignmentsListing(), 500);
        },
        error: (error: ApiError) => {
          this.error = error;
          console.error('License Details ERROR:', error);
          this._baseComponentService.showErrorDialog({ error: this.error });
        },
      })
      .add(() => (this.loading = false));
  }

  async getLicenseAssignmentsListing() {
    if (!this.license || !this.license.id) return;
    this.listingError = undefined;
    this.listingLoading = true;
    this._licenseService
      .getLicenseAssignmentsListing({
        licenseId: this.license.id,
        page: this.pagination?.page || 0,
        limit: this.pagination?.limit || 25,
      })
      .subscribe({
        next: (response: any) => {
          this.pagination = new ApiPagination(response.pagination);
          this.licenseAssignmentsListing = response.data.map(
            (json: any) => new LicenseAssignment(json)
          );
        },
        error: (error: any) => {
          this.listingError = new ApiError(error);
          console.error(
            'License Assignments Listing ERROR:',
            this.listingError
          );
        },
      })
      .add(() => (this.listingLoading = false));
  }

  fakeFunc(): void {}
}
